const SETTLEMENTS_SETTINGS = `/api/v1/settlements/settings`;
const SETTLEMENTS_SETTINGS_V2 = `/api/v2/setting`;

export const SETTLEMENT_MEALS = `${SETTLEMENTS_SETTINGS}/meal`;
export const SETTLEMENT_STAYS = `${SETTLEMENTS_SETTINGS_V2}/stay`;
export const SETTLEMENT_OVERALL = `${SETTLEMENTS_SETTINGS}/general`;
export const VAT_RATES = `${SETTLEMENTS_SETTINGS}/vat-rates`;
export const PAYU_CREDENTIALS = `${SETTLEMENTS_SETTINGS}/payu-credentials`;
